import { toAppHome, closeCurrentWebView } from "@/utils/native/interaction";

export default [
  {
    path: "/tbr-scan/appeal-record",
    name: "TaskDetail",
    meta: {
      title: "申诉记录",
      showHeader: true,
      customBackFn: closeCurrentWebView
    },
    component: () => import("@/views/tbr-scan/appeal-record/index.vue")
  },
  {
    path: "/tbr-scan/outbound/warranty-bind",
    name: "OutboundDetail",
    meta: {
      title: "绑定联保卡",
      showHeader: true,
      customBackFn() {
        const _this: any = this;
        const { back } = _this.$route.query;
        console.log(13, back);
        if (back) {
          _this.$router.back();
        } else {
          toAppHome();
        }
      }
    },
    component: () => import("@/views/tbr-scan/outbound/warranty-bind/index.vue")
  },
  {
    path: "/tbr-scan/inbound/detail",
    name: "InboundDetail",
    meta: {
      title: "详情",
      showHeader: true
    },
    component: () => import("@/views/tbr-scan/inbound/detail/index.vue")
  },
  {
    path: "/tbr-scan/outbound/detail",
    name: "OutboundDetail",
    meta: {
      title: "详情",
      showHeader: true
    },
    component: () => import("@/views/tbr-scan/inbound/detail/index.vue")
  },
  {
    path: "/tbr-scan/warranty-record",
    name: "WarrantyRecord",
    meta: {
      title: "联保记录",
      showHeader: false
    },
    component: () => import("@/views/tbr-scan/warranty-record/index.vue")
  },
  {
    path: "/tbr-scan/warranty-record/detail",
    name: "WarrantyRecordDetail",
    meta: {
      title: "详情",
      showHeader: true
    },
    component: () => import("@/views/tbr-scan/warranty-record/detail.vue")
  },
  {
    path: "/wt-tbr-mini-jump",
    name: "WtTbrMiniJump",
    meta: {
      title: "跳转中",
      showHeader: false,
      unusedToken: true
    },
    component: () => import("@/views/tbr-scan/wx-jump/tbr-mini.vue")
  }
];
